function detectTrialId(hostname) {
  /* eslint-disable-next-line */
  const hostParts = hostname.split('.');
  const subdomain = hostParts.length > 1 ? hostParts[0].toLowerCase() : '';
  let trialId = '';
  if (subdomain && subdomain !== 'www') {
    let envKey = '';
    if (subdomain === 'lupus') {
      envKey = 'VUE_APP_PATIENTSUP_STUDY_ID_LUPUS';
    } else if (subdomain === 'demo') {
      envKey = 'VUE_APP_PATIENTSUP_STUDY_ID_DEMO';
    } 
    trialId = process.env[envKey];
  }
  
  return trialId;
}

export default {
  detectTrialId,
}; 